import React from 'react'
import styled from 'styled-components'
import { RightOutlined } from '@ant-design/icons'
import { CDNImage } from '~/components/ui/CDNImage'
import { msgList_msgList_edges_node } from '~/graphqls/types'
import { toYMDHms } from '~/utils'

const MsgWrapper = styled.div`
  width: 100%;
  background: ${props => props.theme['neutral-200']};
  border-radius: 16px;
  padding: 0 16px;
  color: ${props => props.theme['neutral-800']};
  .msg {
    &-header {
      display: flex;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid ${props => props.theme['neutral-300']};
      &-left {
        display: flex;
        &__icon {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        &__type {
          font-size: 14px;
          line-height: 24px;
          margin-right: 21px;
          color: ${props => props.theme['neutral-800']};
          font-weight: 500;
        }
      }
      &-time {
        color: ${props => props.theme['neutral-800']};
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
    }
    &-content {
      padding: 6px 0 16px;
      &__title {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: ${props => props.theme['neutral-800']};
        padding-top: 10px;
      }
      &__info {
        padding-top: 8px;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: ${props => props.theme['neutral-400']};
      }
      &__link {
        text-align: right;
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
        color: ${props => props.theme.primary};
      }
    }
  }
`

export const MessageInfo: React.FC<{
  msg: msgList_msgList_edges_node
  style?: React.CSSProperties
  className?: string
}> = ({ msg, style, className }) => {
  return (
    <MsgWrapper className={className} style={style}>
      <div className="msg-header">
        <div className="msg-header-left">
          <div className="msg-header-left__icon">
            <CDNImage src="/images/msg/blackBell.svg" alt="" />
          </div>
          <div className="msg-header-left__type">
            {msg?.baseMsgTypeStr || ''}
          </div>
        </div>
        <div className="msg-header-time">{toYMDHms(msg?.time)}</div>
      </div>
      <div className="msg-content">
        {!!msg?.title && msg?.title !== '无界版图' && (
          <div className="msg-content__title">{msg?.title}</div>
        )}
        {msg?.content && (
          <div className="msg-content__info">{msg?.content}</div>
        )}
        {msg?.weblink && (
          <div className="msg-content__link">
            <a href={msg?.weblink} target="_blank" rel="noreferrer">
              去看看
              <RightOutlined style={{ marginLeft: 2 }} />
            </a>
          </div>
        )}
      </div>
    </MsgWrapper>
  )
}
